import { Injectable, signal } from '@angular/core';

import { IDataEntry } from '../features/data-entry/viewmodels/data-entry.viewmodel';

@Injectable({
  providedIn: 'root',
})
export class StoreStateService {
  readonly #dataEntry = signal<IDataEntry | undefined>(undefined);
  readonly dataEntry = this.#dataEntry.asReadonly();

  updateDataEntry(dataEntry: IDataEntry | undefined) {
    this.#dataEntry.set(dataEntry);
  }
}
